import React, { memo } from 'react';
import { ApplicationIcon, Box, Typography } from '@saviynt/design-system';

import { ComingAppIcons } from '../../../../constants/obNextGenConstants';
import useLocalization from '../../../../hooks/use-localize';

import './DiscoverCMDBFooter.css';

const DiscoverCMDBFooter = memo(() => {
  const formatMessage = useLocalization();

  return (
    <section className='Discovery-Container-footer'>
      <Typography kind='body1' desktop='body1-d' mobile='body1-d'>
        {formatMessage('INTEGRATIONS.DISCOVERY.COMINGSOON', 'Coming Soon')}
      </Typography>
      <Box className='Discovery-Container-footer-icon'>
        {ComingAppIcons.map((logo) => (
          <ApplicationIcon key={logo} logo={logo} size='xxSmall' />
        ))}
      </Box>
    </section>
  );
});

export default DiscoverCMDBFooter;
